import React, { useState } from "react";
import Select from "react-select";
import "../../../PanelGerarRelatorios/index.css";
import { Button } from "rsuite";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";

import {
  getResumoComprasExcel,
  getProdutor,
  getSafras,
  getTipoSafra,
} from "../../../../../Services/programation.service";

// Excel resumido de compras POR PRODUTOR:
// Cultura -> tipo de insumo -> produto -> quantidade total (pra comparar/comprar)
export const ResumoCompras = () => {
  const [produtor, setProdutor] = useState(null);
  const [safra, setSafra] = useState(null);
  const [tipoSafra, setTipoSafra] = useState(null);
  const [gerando, setGerando] = useState(false);

  const optionsMap = (res) =>
    (res?.data || [])
      .filter((x) => !x.excluido)
      .map((x) => ({ label: x.nome, value: x.id }));

  const produtoresQuery = useQuery(["rcProdutores"], async () => {
    const { res } = await getProdutor();
    return optionsMap(res);
  });
  const safrasQuery = useQuery(["rcSafras"], async () => {
    const { res } = await getSafras();
    return optionsMap(res);
  });
  const tiposQuery = useQuery(["rcTipos"], async () => {
    const { res } = await getTipoSafra();
    return optionsMap(res);
  });

  const handleDownload = async () => {
    if (!produtor || !safra || !tipoSafra) {
      toast.warning("Escolha o produtor, a safra e o tipo de safra.");
      return;
    }
    setGerando(true);
    const { res } = await getResumoComprasExcel(
      produtor.value,
      safra.value,
      tipoSafra.value
    );
    setGerando(false);
    if (!res?.data || res.status === 404) {
      toast.warning("Nada programado para esse produtor nessa safra.");
      return;
    }
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `Resumo_${produtor.label}_${safra.label}.xlsx`
    );
    link.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="generating-container-reports">
      <div style={{ display: "flex", margin: "15px", flexWrap: "wrap" }}>
        <div className="select-content-relatorio-agrupado">
          Selecione o Produtor
          <Select
            value={produtor}
            onChange={setProdutor}
            options={produtoresQuery.data}
            placeholder=""
          />
        </div>
        <div className="select-content-relatorio-agrupado">
          Selecione a Safra
          <Select
            value={safra}
            onChange={setSafra}
            options={safrasQuery.data}
            placeholder=""
          />
        </div>
        <div className="select-content-relatorio-agrupado">
          Selecione o Tipo Safra
          <Select
            value={tipoSafra}
            onChange={setTipoSafra}
            options={tiposQuery.data}
            placeholder=""
          />
        </div>
      </div>
      <Button
        className="button-generate-reports"
        variant="danger"
        size="lg"
        loading={gerando}
        onClick={handleDownload}
        style={{ marginLeft: "20px" }}
      >
        Gerar Planilha
      </Button>
    </div>
  );
};
